/**
 * i18n Routing Configuration
 *
 * Defines the active locales and routing behavior for next-intl.
 * This is the single source of truth shared between middleware, navigation,
 * and layout validation.
 *
 * Note: ACTIVE_LOCALES is a subset of all supported locales (see config.ts).
 * Add a locale here only when its translation file (src/messages/<locale>.json) exists.
 */

import { defineRouting } from 'next-intl/routing';

/**
 * Locales with complete translation files.
 * Add new locales here as their translations are completed.
 */
export const ACTIVE_LOCALES = ['en', 'nl', 'nl-BE', 'fr', 'fr-BE'] as const;
export type ActiveLocale = (typeof ACTIVE_LOCALES)[number];

export const routing = defineRouting({
  locales: ACTIVE_LOCALES,
  defaultLocale: 'en',

  // 'as-needed': no prefix for default locale (en), prefix for others (/nl/)
  localePrefix: 'as-needed',

  // Detect locale from Accept-Language header and NEXT_LOCALE cookie
  localeDetection: true,
});
